import type { FC } from "react";
import Glyph from "../../assets/Glyph";
import type { RewardItem } from "../../types";
import AmountPill from "../AmountPill";
import Pill from "../Pill";

type Props = {
  item: RewardItem;
};

const RewardPill: FC<Props> = ({ item }) => {
  if (item.type === "currency") return <AmountPill amount={item.label} />;

  return (
    <Pill tone="soft" size="md" className="bg-card">
      <Glyph name={item.type} />
      {item.label}
    </Pill>
  );
};

export default RewardPill;
